import { createFileRoute } from "@tanstack/react-router";

import { AdminSettingsPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/settings")({
  component: AdminSettingsPage,
});
